var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.4C5.483 15.4 7.345 13 7.345 13C7.345 13 9.207 15.4 11.69 15.4C14.172 15.4 16.655 13 16.655 13C16.655 13 19.138 15.4 21 15.4M3 21C5.483 21 7.345 18.6 7.345 18.6C7.345 18.6 9.207 21 11.69 21C14.172 21 16.655 18.6 16.655 18.6C16.655 18.6 19.138 21 21 21",
    stroke: "#286795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141 11.8025L7.17657 7.45708C7.11236 7.39124 7.06677 7.31991 7.03981 7.2431C7.01327 7.16629 7 7.08399 7 6.9962C7 6.90842 7.01327 6.82612 7.03981 6.7493C7.06677 6.67249 7.11236 6.60116 7.17657 6.53533L11.4141 2.18992C11.5318 2.06922 11.6789 2.00601 11.8552 2.0003C12.032 1.99504 12.1846 2.05824 12.313 2.18992C12.4414 2.31063 12.5084 2.4614 12.514 2.64224C12.5191 2.82352 12.4575 2.97999 12.3291 3.11167L9.18299 6.33781H16.3579C16.5399 6.33781 16.6925 6.40079 16.8157 6.52677C16.9386 6.65318 17 6.80966 17 6.9962C17 7.18275 16.9386 7.339 16.8157 7.46498C16.6925 7.59139 16.5399 7.6546 16.3579 7.6546H9.18299L12.3291 10.8807C12.4468 11.0014 12.5084 11.1551 12.514 11.3416C12.5191 11.5282 12.4575 11.6818 12.3291 11.8025C12.2113 11.9342 12.0615 12 11.8796 12C11.6977 12 11.5425 11.9342 11.4141 11.8025Z",
    fill: "#286795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrent);
export default __webpack_public_path__ + "static/media/current.69ef32aecc4b258afd9267cedcd2e4e5.svg";
export { ForwardRef as ReactComponent };